<template>
  <div>
    <bread-crumb></bread-crumb>
    <manFormList
      :select="select"
      :selectList="selectList"
      :isBtn="isBtn"
      @empty="empty"
      @getChangeValue="getChangeValue"
    ></manFormList>
    <div class="box-table">
      <div class="tools">
        <el-tabs v-model="activeName" @tab-click="tabsHandleClick">
          <el-tab-pane
            :label="item.label"
            :name="item.label"
            v-for="(item, index) in tabInfo"
            :key="index"
          >
            <span slot="label" class="slot-item">
              <span>{{ item.label }}</span
              ><span>{{ item.value }}</span>
            </span>
          </el-tab-pane>
        </el-tabs>
        <el-row>
          <el-button type="primary" @click="onMultiImport">批量导入</el-button>
          <el-popconfirm
            title="确定要批量通过吗？"
            class="toolsItem"
            @confirm="batchProcessing('health_cmp_biz_batchPassComments')"
            ><el-button
              slot="reference"
              type="success"
              :disabled="!seletedListIds.length"
              >批量通过</el-button
            ></el-popconfirm
          >
          <el-popconfirm
            title="确定要批量驳回吗？"
            class="toolsItem"
            @confirm="batchProcessing('health_cmp_biz_batchRejectComments')"
            ><el-button
              slot="reference"
              type="warning"
              :disabled="!seletedListIds.length"
              >批量驳回</el-button
            ></el-popconfirm
          >
          <el-popconfirm
            title="确定要批量删除吗？"
            class="toolsItem"
            @confirm="batchProcessing('health_cmp_biz_deleteRejectComments')"
            ><el-button
              slot="reference"
              type="danger"
              :disabled="!seletedListIds.length"
              >批量删除</el-button
            ></el-popconfirm
          >
          <el-popconfirm
            title="确定要批量恢复吗？"
            class="toolsItem"
            @confirm="batchProcessing('health_cmp_biz_batchRecoveryComments')"
            ><el-button
              slot="reference"
              type="info"
              :disabled="!seletedListIds.length"
              >批量恢复</el-button
            ></el-popconfirm
          >
        </el-row>
      </div>
      <el-table
        :data="tableList"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        ref="multipleTable"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="commentId" label="ID" width="70">
        </el-table-column>
        <el-table-column prop="comments" label="评论内容">
          <template slot-scope="scope">
            <div>
              <div class="commits" v-html="scope.row.comments"></div>
              <el-button
                @click="openImage(scope.row)"
                v-if="scope.row?.extendMap?.image"
                >查看图片</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="contentDetail" label="文章内容">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.contentDetail"
              placement="top-start"
            >
              <div class="contentDetail">
                {{
                  scope.row.contentDetail?.length > 20
                    ? scope.row.contentDetail.slice(0, 20) + "..."
                    : scope.row.contentDetail
                }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="文章ID" prop="contentId" width="70">
          <template slot-scope="scope">
            <div>{{ scope.row.contentId }}</div>
          </template>
        </el-table-column>
        <el-table-column label="文章标题" prop="contentTitle">
          <template slot-scope="scope">
            <div>
              <a
                v-if="!(scope.row?.targetType && scope.row?.targetType === 9)"
                class="Url"
                :href="`${isUrl}${scope.row.contentId}`"
                >{{ scope.row.contentName }}</a
              >
              <a class="Url" v-else @click="handleTitleClick(scope.row)">{{
                scope.row.contentName
              }}</a>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="圈子"
          prop="extentdMap"
          v-if="tenantid == 484 || tenantid == 492"
        >
          <template slot-scope="scope">
            <div>
              {{
                (scope.row.extendMap && scope.row.extendMap.communityName) || ""
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="医生信息"
          prop="auditUser"
          v-if="tenantid != 484 && tenantid != 492"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.doctorInfoDTO ? true : false">
              <p v-if="scope.row.doctorInfoDTO.docName ? true : false">
                {{ scope.row.doctorInfoDTO.docName }}
              </p>
              <p v-if="scope.row.doctorInfoDTO.docTitleName ? true : false">
                {{ scope.row.doctorInfoDTO.docTitleName }}
              </p>
              <p v-if="scope.row.doctorInfoDTO.hospitalName ? true : false">
                {{ scope.row.doctorInfoDTO.hospitalName }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="用户Pin" prop="commentPin"> </el-table-column>
        <el-table-column label="评论时间" prop="commentTime" width="95">
        </el-table-column>
        <el-table-column
          label="归属地"
          prop="commentIpAddress.location"
          width="70"
        >
        </el-table-column>
        <el-table-column label="驳回原因" prop="auditComment">
        </el-table-column>
        <el-table-column label="评论来源" prop="commentSource" width="60">
          <template slot-scope="scope">
            <div>{{ commentSourceMap[scope.row.commentSource - 1] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="auditStatus" width="60">
          <template slot-scope="scope">
            <div>{{ scope.row.auditStatus | auditStatus }}</div>
          </template>
        </el-table-column>
        <el-table-column label="评论分级" prop="commentLevel">
          <template slot-scope="scope">
            <div class="rank-buttons" v-if="scope?.row?.auditStatus == 2">
              <el-button-group>
                <el-button
                  size="mini"
                  :type="scope?.row?.commentLevel === 1 ? 'primary' : ''"
                  @click="setcommentLevel(scope.row, 'S')"
                  >S</el-button
                >
                <el-button
                  size="mini"
                  :type="scope?.row?.commentLevel === 2 ? 'primary' : ''"
                  @click="setcommentLevel(scope.row, 'A')"
                  >A</el-button
                >
                <el-button
                  size="mini"
                  :type="scope?.row?.commentLevel === 3 ? 'primary' : ''"
                  @click="setcommentLevel(scope.row, 'B')"
                  >B</el-button
                >
                <el-button
                  size="mini"
                  :type="scope?.row?.commentLevel === 4 ? 'primary' : ''"
                  @click="setcommentLevel(scope.row, 'C')"
                  >C</el-button
                >
                <el-button
                  size="mini"
                  :type="scope?.row?.commentLevel === 5 ? 'primary' : ''"
                  @click="setcommentLevel(scope.row, 'D')"
                  >D</el-button
                >
              </el-button-group>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div>
              <el-popconfirm
                title="确定通过吗？"
                class="toolsItem"
                @confirm="handleClick(scope.row, 'pass')"
                v-if="scope.row.auditStatus === 1"
              >
                <el-button type="text" size="small" slot="reference"
                  >通过</el-button
                >
              </el-popconfirm>
              <span class="border" v-if="scope.row.auditStatus === 1"></span>
              <el-popconfirm
                title="确定驳回吗？"
                class="toolsItem"
                @confirm="handleClick(scope.row, 'reject')"
                v-if="scope.row.auditStatus === 1"
              >
                <el-button type="text" size="small" slot="reference"
                  >驳回</el-button
                >
              </el-popconfirm>
              <span class="border" v-if="scope.row.auditStatus === 1"></span>
              <el-popconfirm
                title="确定要置顶吗？"
                class="toolsItem"
                @confirm="handleClick(scope.row, 'stick')"
                v-if="scope.row.auditStatus === 2 && scope.row.topStatus === 0"
              >
                <el-button type="text" size="small" slot="reference"
                  >置顶</el-button
                >
              </el-popconfirm>
              <span
                class="border"
                v-if="scope.row.auditStatus === 2 && scope.row.topStatus === 0"
              ></span>
              <el-popconfirm
                title="确定要取消置顶吗？"
                class="toolsItem"
                @confirm="handleClick(scope.row, 'cancelStick')"
                v-if="scope.row.auditStatus === 2 && scope.row.topStatus === 1"
              >
                <el-button type="text" size="small" slot="reference"
                  >取消置顶</el-button
                >
              </el-popconfirm>
              <span
                class="border"
                v-if="scope.row.auditStatus === 2 && scope.row.topStatus === 1"
              ></span>
              <el-popconfirm
                title="确定要删除吗？"
                class="toolsItem"
                @confirm="handleClick(scope.row, 'delete')"
              >
                <el-button type="text" size="small" slot="reference"
                  >删除</el-button
                >
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    ></pagination>
    <!-- 弹框-删除 -->
    <modal
      :isShow.sync="isShowDialog"
      :title="dialogTitle"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="ClickHandler"
    >
      <div class="box_text">{{ dialogText }}</div>
    </modal>
    <el-drawer
      :visible.sync="dialogSetCircle"
      direction="rtl"
      size="40%"
      @close="closeDrawer()"
    >
      <!-- <div class="header-container">
				<div class="header">帖子详情</div>
			</div> -->
      <div style="margin-top: 10px" class="form-container">
        <el-form
          :model="circleForm"
          :rules="circleRules"
          ref="circleForm"
          label-width="160px"
        >
          <!-- 帖子ID -->
          <el-form-item label="帖子ID">
            {{ circleForm.postId }}
          </el-form-item>

          <!-- 帖子审核状态 -->
          <el-form-item label="帖子状态">
            {{ circleForm.auditStatus == 0 ? "待审核" : null }}
            {{ circleForm.auditStatus == 1 ? "审核通过" : null }}
            {{ circleForm.auditStatus == 2 ? "审核拒绝" : null }}
          </el-form-item>

          <!-- 发布者 -->
          <el-form-item label="发布者">
            {{ circleForm.nickName }}
          </el-form-item>

          <!-- 发布者 -->
          <el-form-item label="用户pin">
            {{ circleForm.pin }}
          </el-form-item>

          <!-- 用户发布时间 -->
          <el-form-item label="发布时间">
            {{ formatDate(circleForm.submitTime) }}
          </el-form-item>

          <!-- 所属圈子名称 -->
          <el-form-item label="所属圈子">
            {{ circleForm.communityName }}
          </el-form-item>

          <!-- 帖子话题名称列表 -->
          <el-form-item label="用户关联话题">
            {{ circleForm?.topicNameList?.topicName }}
          </el-form-item>

          <!-- 圈子类型 -->
          <!-- <el-form-item label="圈子类型" >
            {{ circleForm.communityType }}
          </el-form-item> -->

          <!-- 标题 -->
          <el-form-item label="帖子标题">
            {{ circleForm.title }}
          </el-form-item>

          <!-- 正文 -->
          <el-form-item label="帖子正文">
            {{ circleForm.content }}
          </el-form-item>

          <!-- 小图 -->
          <el-form-item label="图文视频" label-width="160px" prop="imageUrl">
            <div class="image-flex" v-if="circleForm.contentPicUrl">
              <div
                v-for="(url, index) in JSON.parse(circleForm.contentPicUrl)"
                :key="index"
                class="image-item"
              >
                <img
                  :src="
                    url.startsWith(imgHost) ||
                    url.startsWith('http://storage.jd.local') ||
                    url.startsWith('https') ||
                    url.startsWith('http') ||
                    url.startsWith('https://jkimg10.360buyimg.com') ||
                    url.startsWith('https://storage.360buyimg.com')
                      ? url
                      : `${imgHost}${url}`
                  "
                  alt="图片"
                  @click="handleImageClick(url)"
                />
                <div class="image-overlay">
                  <el-button
                    @click="
                      viewImage(
                        url.startsWith(imgHost) ||
                          url.startsWith('http://storage.jd.local') ||
                          url.startsWith('https') ||
                          url.startsWith('http') ||
                          url.startsWith('https://jkimg10.360buyimg.com') ||
                          url.startsWith('https://storage.360buyimg.com')
                          ? url
                          : `${imgHost}${url}`
                      )
                    "
                    type="primary"
                    icon="el-icon-zoom-in"
                    size="mini"
                  ></el-button>
                </div>
              </div>
            </div>
            <div v-else>暂无图片</div>
            <div class="image-flex" v-if="circleForm.postVideoInfo">
              <video
                ref="videoPlayer"
                :src="circleForm.postVideoInfo.playUrl"
                controls
                style="width: 100%"
              ></video>
            </div>
          </el-form-item>
          <!-- 敏感 -->
          <el-form-item label="是否含敏感内容">
            {{
              circleForm?.postExtDTO?.sensitiveWordInfo ||
              circleForm?.postExtDTO?.isImageSensitiveWord ||
              circleForm?.postExtDTO?.isImagePorn
                ? "是"
                : "否"
            }}
          </el-form-item>
          <!-- 敏感内容 -->
          <el-form-item
            v-if="
              circleForm?.postExtDTO?.sensitiveWordInfo ||
              circleForm?.postExtDTO?.isImageSensitiveWord ||
              circleForm?.postExtDTO?.isImagePorn
            "
            label="所含敏感内容"
          >
            <div v-if="circleForm?.postExtDTO?.sensitiveWordInfo">
              <span>敏感词信息:</span>
              {{ circleForm?.postExtDTO?.sensitiveWordInfo }}
            </div>
            <div
              v-if="circleForm?.postExtDTO?.isImageSensitiveWord"
              style="margin-left: 20px"
            >
              <span>图片包含敏感词:</span>
              {{ circleForm?.postExtDTO?.isImageSensitiveWord ? "是" : "否" }}
            </div>
            <div
              v-if="circleForm?.postExtDTO?.isImagePorn"
              style="margin-left: 20px"
            >
              <span>图片包含涉黄信息:</span>
              {{ circleForm?.postExtDTO?.isImagePorn ? "是" : "否" }}
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button @click="closeDrawer()">关闭</el-button>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="dialogVisible" width="50%">
      <img :src="currentImageUrl" alt="图片" style="width: 100%" />
    </el-dialog>
    <!-- 批量导入弹窗 -->
    <el-dialog title="批量导入" :visible.sync="dialogMultiImport" width="400px">
      <div v-if="dialogMultiImport">
        <input
          type="file"
          @change="fileChange"
          ref="file"
          style="margin-bottom: 20px"
        />
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="uploadCategoryExl"
        >
          {{ uploadShow ? "上传中" : "上传" }}
        </el-button>
        <el-button size="medium" @click="downloadCategoryExl">
          下载最新模板
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from "../../../../utils";
import baseTable from "../../../../components/baseTable";
import manFormList from "../../components/manFormList";
import breadCrumb from "../../../../components/breadCrumb";
import modal from "@/components/modal";
import pagination from "../../../../components/pagination";
import {
  getOutArticleCategory,
  uploadCategoryExl,
  fileChange,
} from "../../../man/components/importExportCommon.js";
import { mapState } from "vuex";
import {
  pageManCommentInfos,
  passCommentInfo,
  rejectCommentInfo,
  deleteManCommentInfo,
  addCommentInfoTopStatus,
  cancelCommentInfoTopStatus,
  health_cmp_biz_batchPassComments,
  health_cmp_biz_batchRejectComments,
  health_cmp_biz_deleteRejectComments,
  health_cmp_biz_batchRecoveryComments,
  health_cmp_queryCommentSourceFilter,
  health_cmp_queryAllCommentCounts,
  getImportTemplate,
  health_cmp_biz_setCommentLevel,
} from "@/api/man";
export default {
  data() {
    return {
      tabInfo: [],
      activeName: "all",
      dialogSetCircle: false,
      dialogVisible: false,
      circleForm: {
        businessId: null,
        title: "",
        hotValue: "",
        content: "",
        communityType: "",
        pin: "",
        contentPicUrlList: [],
        contentPicUrl: "",
        isTopicTop: "",
        communityName: "",
        communityId: "",
        class: "",
        avatarUrl: "",
        nickName: "",
        auditor: "",
        updateUser: "",
        updateTime: "",
        postId: "",
        submitTime: "",
        isCommunityTop: "",
        auditTime: "",
        createTime: "",
        tenantId: parseInt(this.$route.query.tenantid),
        authorIp: "",
        auditStatus: "",
        createUser: "",
        isAutoAudit: "",
        status: "",
        realyName: "",
      },
      // 判断环境
      isUrl: "https://hlc.m.jd.com/doctorArticle/?editable=false&id=",
      // 弹框
      isShowDialog: false,
      dialogTitle: "删除",
      isShowBtn: [true, true],
      btnText: ["取消", "删除"],
      dialogText: "是否确认删除",
      dialogType: "",
      ruleForm: {
        desc: "",
      },
      // form 表单绑定参数
      selectList: {
        contributeTime: "", // 申请时间
        auditStatus: "", // 审核状态
        topStatus: "", // 置顶
        commentPin: "", // 用户Pin
        commentKeyword: "", // 评论内容
        targetTypes: [], // 类型
        commentSources: [], // 来源
        contentIds: "",
      },
      tenantid: null,
      isBtn: 1,
      select: [
        {
          prop: "contributeTime",
          type: "picker",
          placeholder: "请选择申请时间",
        },
        // {
        // 	prop: 'auditStatus',
        // 	type: 'select',
        // 	placeholder: '请选择状态',
        // 	List: [
        // 		{
        // 			label: '待审核',
        // 			value: 1
        // 		},
        // 		{
        // 			label: '审核通过',
        // 			value: 2
        // 		},
        // 		{
        // 			label: '驳回',
        // 			value: 3
        // 		},
        // 		{
        // 			label: '待发布',
        // 			value: 3
        // 		},
        // 	],
        // },
        {
          prop: "topStatus",
          type: "select",
          placeholder: "是否置顶",
          List: [
            {
              label: "已置顶",
              value: 1,
            },
            {
              label: "未置顶",
              value: 0,
            },
          ],
        },
        {
          prop: "commentPin",
          type: "input",
          placeholder: "请输入用户PIN",
          // List: [],
        },
        {
          prop: "commentKeyword",
          type: "input",
          placeholder: "请输入评论内容",
          // List: [],
        },
        {
          prop: "contentIds",
          type: "input",
          placeholder: "请输入内容ID，多个以“,” 或“空格”分割",
          // List: [],
        },
        {
          prop: "targetTypes",
          type: "select",
          placeholder: "请选择内容类型",
          List: [
            {
              label: "帖子",
              value: 9,
            },
            {
              label: "内容",
              value: 2,
            },
          ],
        },
        {
          prop: "commentSources",
          type: "select",
          placeholder: "筛选评论来源",
          List: [],
        },
        {
          prop: "commentLevels",
          type: "select",
          placeholder: "筛选评论分级",
          List: [
            {
              label: "未评级",
              value: 0,
            },
            {
              label: "S",
              value: 1,
            },
            {
              label: "A",
              value: 2,
            },
            {
              label: "B",
              value: 3,
            },
            {
              label: "C",
              value: 4,
            },
            {
              label: "D",
              value: 5,
            },
          ],
        },
      ],
      // table表格
      tableList: [],
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      rules: {
        desc: [{ required: true, message: "请填写驳回理由", trigger: "blur" }],
      },
      tableListValue: {},
      seletedListIds: "",
      // 全局常量
      commentSourceMap: [],

      dialogMultiImport: false,
      fileName: null,
      uploadShow: false,
    };
  },
  components: {
    baseTable,
    manFormList,
    breadCrumb,
    modal,
    pagination,
  },

  async created() {
    this.tenantid = Number(this.$commonJs.getTenantId());
    await this.getAllInfo();
    this.getCommentSources();
    this.pageManCommentInfos();
  },
  computed: {
    ...mapState(["imgHost", "userInfo"]),
  },
  methods: {
    openImage(row) {
      debugger;
      if (row?.extendMap?.image) {
        try {
          const url = JSON.parse(row?.extendMap?.image);
          window.open(url[0], "_blank");
        } catch (e) {}
        // window.open(row?.extendMap?.image?.[0], "_blank");
      }
    },
    setcommentLevel(row, commentLevel) {
      // 这里应该调用后端 API 来更新评级
      // 暂时只在前端更新
      const params = {
        tenantId: Number(this.$commonJs.getTenantId()),
        commentId: row?.commentId,
        commentLevel: ["S", "A", "B", "C", "D"].indexOf(commentLevel) + 1,
      };
      console.log("==== setcommentLevel", row, commentLevel, params);

      health_cmp_biz_setCommentLevel(params).then((res) => {
        this.$set(
          row,
          "commentLevel",
          ["S", "A", "B", "C", "D"].indexOf(commentLevel) + 1
        );
      });
    },
    tabsHandleClick(item) {
      console.log("==== tabClick", item);
      this.selectList.auditStatus = this.tabInfo[item.index]?.key;
      this.pageManCommentInfos();
    },
    async getAllInfo(param) {
      const ret = await health_cmp_queryAllCommentCounts({
        tenantId: Number(this.$commonJs.getTenantId()),
        ...param,
      });

      this.tabInfo = [...ret];
      if (!param) {
        this.activeName = ret?.[0].label;
      }
    },
    async getCommentSources() {
      const res = await health_cmp_queryCommentSourceFilter({});
      // console.log(res)
      // this.selectList = {
      // 	...this.selectList,
      // 	commentSources : [...res]
      // };
      this.commentSourceMap = res.map((item) => {
        return item.label;
      });

      this.select = this.select.map((item) => {
        if (item.prop == "commentSources") {
          return {
            prop: "commentSources",
            type: "select",
            multiple: "multiple",
            placeholder: "筛选评论来源",
            List: res,
          };
        } else {
          return { ...item };
        }
      });
      // console.log(3333,this.commentSources)
    },
    uploadCategoryExl() {
      uploadCategoryExl(this, 17);
    },
    downloadCategoryExl() {
      getImportTemplate({
        importExportCode: 17,
      }).then((res) => {
        if (res.templateUrl) {
          const excelUrl = res.templateUrl.replace(
            "http://storage.jd.local",
            "https://storage.360buyimg.com"
          );
          window.location.href = excelUrl;
          this.$message.success(`下载成功`);
        }
      });
    },
    // 上传文件校验
    async fileChange(e) {
      fileChange(e, this, 5);
    },
    onMultiImport() {
      console.log("==== onMultiImport");
      this.dialogMultiImport = true;
      this.fileName = null;
    },
    closeDrawer() {
      this.dialogSetCircle = false;
      this.circleForm = {
        businessId: null,
        title: "",
        hotValue: "",
        content: "",
        communityType: "",
        pin: "",
        contentPicUrlList: [],
        contentPicUrl: "",
        isTopicTop: "",
        communityName: "",
        communityId: "",
        class: "",
        avatarUrl: "",
        nickName: "",
        auditor: "",
        updateUser: "",
        updateTime: "",
        postId: "",
        submitTime: "",
        isCommunityTop: "",
        auditTime: "",
        createTime: "",
        tenantId: parseInt(this.$route.query.tenantid),
        authorIp: "",
        auditStatus: "",
        createUser: "",
        isAutoAudit: "",
        status: "",
        realyName: "",
      };
    },
    viewImage(url) {
      this.currentImageUrl = url;
      this.dialogVisible = true;
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const pad = (n) => n.toString().padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    handleTitleClick(row) {
      console.log(row);
      this.circleForm = {
        ...this.circleForm,
        ...row.extendMap.communityPost,
      };
      this.dialogSetCircle = true;
    },
    async batchProcessing(requestApit) {
      const apiMap = {
        health_cmp_biz_batchPassComments,
        health_cmp_biz_batchRejectComments,
        health_cmp_biz_deleteRejectComments,
        health_cmp_biz_batchRecoveryComments,
      };
      apiMap[requestApit]({
        tenantId: Number(this.$commonJs.getTenantId()),
        commentIds: this.seletedListIds.split(",").map((item) => Number(item)),
        auditComment: "",
      })
        .then((ret) => {
          console.log(ret, "ret=====>");
          if (ret) {
            this.$message({
              message: "执行成功",
              type: "success",
            });
            this.$refs.multipleTable.clearSelection();
            this.seletedListIds = "";
            setTimeout(() => {
              this.getChangeValue();
            }, 1000);
          } else {
            this.$message.error("执行失败");
          }
        })
        .catch((e) => this.$message.error("执行失败"));
    },
    handleSelectionChange(ele) {
      // console.log(ele, data, '00000000');
      const ids = ele
        .map((obj) => obj?.commentId)
        .filter((commentId) => commentId !== undefined && commentId !== null);
      // console.log(ids)
      this.seletedListIds = ids.join(",");
    },
    // table-按钮
    handleClick(data, type) {
      this.dialogType = type;
      // this.isShowDialog = true
      this.tableListValue = data;
      this.ClickHandler();
    },
    // 查询
    getChangeValue() {
      this.paginationDataProduct.currentPage = 1;
      this.paginationDataProduct.pageSize = 10;
      this.pageManCommentInfos();
    },
    // 重置
    empty(list) {
      this.paginationDataProduct.currentPage = 1;
      this.paginationDataProduct.pageSize = 10;
      Object.keys(this.selectList).map((item) => {
        console.log(this.selectList[item]);
        if (item == "commentSources") {
          this.selectList[item] = [];
        } else {
          this.selectList[item] = "";
        }
      });
      this.pageManCommentInfos();
    },
    // 分页
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.pageManCommentInfos();
    },
    // 弹框操作按钮
    ClickHandler(val) {
      if (val === "one") {
        this.isShowDialog = false;
      } else {
        switch (this.dialogType) {
          // 通过
          case "pass":
            this.passCommentInfo();
            return;
          // 驳回
          case "reject":
            this.rejectCommentInfo();
            return;
          // 置顶
          case "stick":
            this.addCommentInfoTopStatus();
            return;
          // 取消置顶
          case "cancelStick":
            this.cancelCommentInfoTopStatus();
            return;
          // 删除
          case "delete":
            this.deleteManCommentInfo();
            return;
          default:
            this.isShowDialog = false;
            return;
        }
      }
    },
    // 分页请求
    async pageManCommentInfos() {
      console.log(this.selectList.auditStatus, "----------");
      const tempTargetTypes = Array.isArray(this.selectList.targetTypes)
        ? this.selectList.targetTypes[0] === "全部"
          ? []
          : this.selectList.targetTypes
        : this.selectList.targetTypes === "全部"
        ? []
        : this.selectList.targetTypes
        ? [this.selectList.targetTypes]
        : [];
      const tempCommentLevels = Array.isArray(this.selectList.commentLevels)
        ? this.selectList.commentLevels[0] === "全部"
          ? []
          : this.selectList.commentLevels
        : this.selectList.commentLevels === "全部"
        ? []
        : this.selectList.commentLevels != undefined
        ? [this.selectList.commentLevels]
        : [];
      let data = {
        tenantId: Number(this.$commonJs.getTenantId()),
        beginTime: utils.isEmpty(this.selectList.contributeTime)
          ? null
          : utils.timetamp(Number(this.selectList.contributeTime[0])), // 评论开始时间
        endTime: utils.isEmpty(this.selectList.contributeTime)
          ? null
          : utils.timetamp(Number(this.selectList.contributeTime[1])), // 结束时间
        auditStatus:
          this.selectList.auditStatus && this.selectList.auditStatus !== "全部"
            ? [this.selectList.auditStatus]
            : [], // 审核状态
        topStatus:
          (this.selectList.topStatus != "" || this.selectList.topStatus == 0) &&
          this.selectList.topStatus != "全部"
            ? this.selectList.topStatus
            : null, // 置顶状态
        commentPin: this.selectList.commentPin
          ? this.selectList.commentPin
          : null, // 评论人Pin
        commentKeyword: this.selectList.commentKeyword
          ? this.selectList.commentKeyword
          : "", // 评论内容
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        targetTypes: tempTargetTypes || [],
        commentSources: this.selectList.commentSources || [],
        contentIds: this.selectList.contentIds
          ? this.selectList.contentIds.split(/[, ]+/)
          : [],
        withKangkangComment: this.selectList.commentSources.includes(3)
          ? true
          : null,
        withAgentRoleComment: this.selectList.commentSources.includes(9)
          ? true
          : null,
        commentLevels: tempCommentLevels || [],
      };
      await this.getAllInfo(data);
      pageManCommentInfos(data).then((res) => {
        // console.log(res.data);
        this.tableList.splice(0, this.tableList.length);
        res.data.map((item) => {
          if (item.commentSources) {
            item.commentSources = this.commentSourceMap[item.commentSources];
          }
          // 添加 commentLevel 字段，如果后端没有提供，默认为空字符串
          item.commentLevel = item?.commentLevel || "";
          this.tableList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
      });
    },
    // 通过
    passCommentInfo() {
      // console.log(this.tableListValue.contentId);
      console.log(this.tableListValue.commentId);
      let data = {
        tenantId: this.$commonJs.getTenantId(),
        // contentId: this.tableListValue.contentId,
        commentId: this.tableListValue.commentId,
        // contentType: this.tableListValue.contentType
      };
      passCommentInfo(data).then((res) => {
        console.log(res);
        if (res) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$message.error("操作失败");
        }
        this.passDialog = false;
        this.isShowDialog = false;
        this.pageManCommentInfos();
      });
    },
    // 驳回
    rejectCommentInfo() {
      let data = {
        tenantId: this.$commonJs.getTenantId(),
        commentId: this.tableListValue.commentId,
      };
      rejectCommentInfo(data)
        .then((res) => {
          console.log(res);
          if (res) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message.error("操作失败");
          }
          this.rejectDialog = false;
          this.isShowDialog = false;
          this.pageManCommentInfos();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 置顶
    addCommentInfoTopStatus() {
      let data = {
        tenantId: this.$commonJs.getTenantId(),
        commentId: this.tableListValue.commentId,
      };
      addCommentInfoTopStatus(data)
        .then((res) => {
          console.log(res);
          if (res) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message.error("操作失败");
          }
          this.stickDialog = false;
          this.isShowDialog = false;
          this.pageManCommentInfos();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 取消置顶
    cancelCommentInfoTopStatus() {
      let data = {
        tenantId: this.$commonJs.getTenantId(),
        commentId: this.tableListValue.commentId,
      };
      cancelCommentInfoTopStatus(data)
        .then((res) => {
          console.log(res, "res");
          if (res) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message.error("操作失败");
          }
          this.cancelStickDialog = false;
          this.isShowDialog = false;
          this.pageManCommentInfos();
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("操作失败");
          this.deleteDialog = false;
          this.isShowDialog = false;
        });
    },
    // 删除
    deleteManCommentInfo() {
      let data = {
        tenantId: this.$commonJs.getTenantId(),
        commentId: this.tableListValue.commentId,
      };
      deleteManCommentInfo(data).then((res) => {
        console.log(res);
        if (res) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$message.error("操作失败");
        }
        this.deleteDialog = false;
        this.isShowDialog = false;
        this.pageManCommentInfos();
      });
    },
  },
  filters: {
    auditStatus(data) {
      switch (data) {
        case 1:
          return "待审核";
        case 2:
          return "审核通过";
        case 3:
          return "驳回";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding-top: 10px;
  padding-right: 20px;
}

.box-table {
  background-color: #fff;
}

.tools {
  padding-top: 15px;
  padding-left: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  :deep(.el-tabs .el-tabs__header) {
    margin-bottom: 0;
  }

  :deep(.el-tabs .el-tabs__content) {
    padding-bottom: 0;
  }
}

.slot-item {
  span {
    margin: 0px 2px 0px 2px;
  }
}

.border {
  margin: 0 5px 0;
  display: inline-block;
  height: 8px;
  width: 1px;
  /* background-color: black; */
  border: 0.9px solid #266cee;
}

.box_text {
  width: 100%;
  text-align: center;
  padding-top: 20px;
  font-size: 16px;
}

.Url {
  color: #266cee;
  cursor: pointer;
}

:deep(.commits) {
  em {
    color: red;
  }
}

.toolsItem {
  margin: 0 10px;
}

.header-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header {
  font-size: 20px;
  font-weight: bold;
}

.form-container {
  height: 80vh;
  /* 设置固定高度 */
  overflow-y: auto;
  /* 启用垂直滚动条 */
}

:deep(.el-form-item__label) {
  font-weight: bold;
  /* 加粗 */
  margin-right: 20px;
  /* 右边距 */
}

.image-flex {
  display: flex;
  flex-wrap: wrap;
  /* 自动换行 */
  gap: 10px;
  /* 图片间距 */
}

.image-item {
  position: relative;
  width: calc(33.33% - 10px);
  /* 每行3个，减去间距 */
  height: 100px;
  /* 设置图片容器高度 */
  overflow: hidden;
  margin-bottom: 10px;
  /* 图片之间的垂直间距 */
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 图片覆盖容器 */
  cursor: pointer;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
}

.image-item:hover .image-overlay {
  opacity: 1;
}

.image-overlay .el-button {
  margin: 0 5px;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.input-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}

.button-group {
  display: flex;
  gap: 10px;
}

.multiSelect {
  display: flex;
  align-items: center;
  // justify-content: center;
  font-size: 16px;
  margin-bottom: 10px;
}

.select-blue {
  margin-right: 5px;
  // color: blue;
}

.select-white {
  margin-right: 5px;
  color: rgb(0, 0, 0);
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
  /* 确保背景色 */
}

.drawer-footer .el-button {
  margin-left: 10px;
}
</style>
